import {
    unauthenticatedSenderInfoBarLink,
    unauthenticatedSenderInfoBarMessage,
} from './createUnauthenticatedSenderInfoBarMessage.locstring.json';
import loc from 'owa-localize';
import Message from 'owa-service/lib/contract/Message';
import {
    InfoBarMessageSource,
    InfoBarMessageRank,
    InfoBarMessageColor,
    InfoBarCustomAction,
    InfoBarMessageViewState,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { logUsage } from 'owa-analytics';
import { isFeatureEnabled } from 'owa-feature-flags';

const learnMoreUrl = 'https://go.microsoft.com/fwlink/?linkid=871490';
const infoBarClickedEventName = 'UnauthenticatedSenderInfoBarClicked';

export default function createUnauthenticatedSenderMessageViewState(
    message: Message,
    key: string
): InfoBarMessageViewState {
    if (
        isFeatureEnabled('peo-unauthenticatedSender') &&
        message &&
        message.AntispamUnauthenticatedSender
    ) {
        const linkAction: InfoBarCustomAction = {
            text: loc(unauthenticatedSenderInfoBarLink),
            action: () => {
                window.open(learnMoreUrl, '_blank');

                // Log custom event on click
                logUsage(infoBarClickedEventName);
            },
        };

        const unauthenticatedSenderInfoBarMessageViewState: InfoBarMessageViewState = {
            key: key,
            source: InfoBarMessageSource.ReadingPane,
            rank: InfoBarMessageRank.Safety,
            color: InfoBarMessageColor.Yellow,
            message: loc(unauthenticatedSenderInfoBarMessage),
            messageParts: [loc(unauthenticatedSenderInfoBarMessage), linkAction],
        };

        return unauthenticatedSenderInfoBarMessageViewState;
    } else {
        return null;
    }
}
